<template>
  <div class="bg">
    <div class="vux-1px-b">
      <x-input
        title="渔船号"
        text-align="right"
        placeholder="请输入渔船号"
        @on-change="getShipNum"
        placeholder-align="right"
      ></x-input>
    </div>
    <div class="next" v-if="loadingImg === true">
      <img class="loadingImg" src="../../assets/loading.gif" />
    </div>
    <div class="next" v-else @click="next">下一步</div>
  </div>
</template>

<script>
export default {
  name: "addShipNum",
  data() {
    return {
      loadingImg: false,
      params: {
        shipNum: ""
      }
    };
  },
  methods: {
    getShipNum() {},
    next() {
      this.$router.push("/ship/addShip");
    }
  }
};
</script>

<style scoped>
.bg {
  background: #fff;
  overflow: hidden;
  font-size: 14px;
}
.next {
  margin: 50px 30px;
  background: #007bec;
  height: 86px;
  line-height: 86px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  letter-spacing: 10px;
}
.loadingImg {
  width: 32px;
  height: 32px;
  line-height: 86px;
}
</style>
